const ITEMS = [
  "Lámina Galvanizada",
  "Fabricantes Directos",
  "Aceros",
  "Desde 2017",
  "Los Mochis, Sinaloa",
  "Lámina Acanalada",
  "Perfiles y Tubos",
  "Corte a Medida",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-[#1A2235] bg-[#0A0E17] py-5 md:py-7 overflow-hidden" data-testid="marquee-ribbon">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-black uppercase tracking-tight text-3xl md:text-5xl text-outline px-6 md:px-10" style={{ fontWeight: 900 }}>
                  {item}
                </span>
                <span className="text-[#FF7A00] text-xl md:text-2xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
